import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { CtaBand } from "../components/CtaBand";
import { SERVICES } from "../data/services";
import { servicePath } from "../data/cities";

export default function ServicesIndex() {
  return (
    <div data-testid="services-index-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-8">
      <Seo
        title="Security Services Ontario | Guards, Patrol, Fire Watch & More"
        description="Full security services across Ontario: uniformed guards, mobile patrol, construction site security, event security, loss prevention, fire watch, K9 & more. +1 807-770-0243."
        path="/security-services"
      />
      <p className="text-xs font-semibold uppercase tracking-widest text-amber-500 mb-3">1st Nations Security — Ontario Security Services</p>
      <h1 className="text-4xl sm:text-5xl font-black tracking-tight text-white font-heading mb-5">
        Security Guard Services in Ontario
      </h1>
      <p className="text-base text-slate-300 leading-relaxed max-w-3xl mb-12">
        1st Nations Security delivers a full range of professional security services across Ontario. Every service is
        delivered by licensed, uniformed security guards backed by our 24/7 dispatch centre — from Thunder Bay and
        Northwestern Ontario to the GTA, Ottawa, Hamilton and Windsor.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {SERVICES.map((s) => (
          <Link
            key={s.slug}
            to={servicePath(s)}
            data-testid={`services-index-card-${s.slug}`}
            className="group flex gap-5 rounded-2xl border border-white/10 bg-slate-900/60 p-6 transition-all duration-200 hover:border-amber-500/40 hover:bg-slate-900"
          >
            <s.icon className="h-10 w-10 text-amber-400 shrink-0" />
            <div>
              <h2 className="text-lg font-semibold text-white mb-2 group-hover:text-amber-300 transition-colors">{s.name}</h2>
              <p className="text-sm text-slate-400 leading-relaxed mb-3">{s.short}</p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-amber-400">
                {s.name} in Ontario <ChevronRight className="h-3.5 w-3.5" />
              </span>
            </div>
          </Link>
        ))}
      </div>
      <CtaBand
        heading="Not Sure Which Security Service You Need?"
        sub="Call our 24/7 dispatch team and describe your site or event — we will recommend the right guard, patrol or watch coverage for your location anywhere in Ontario."
      />
    </div>
  );
}
